const form = document.getElementById('register');

function onSubmit(token) {
  form.submit();
}

const inputMap = {
  email: 'email',
  phone: 'tel',
}

const patternMap = {
  email : "[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\\.[a-z]{2,}$",
  phone : "[0-9]*",
}

const selectContact = document.getElementById('inputContactType');
const inputContact = document.getElementById('inputContact');

selectContact.addEventListener('change', function(){
  const placeholder = selectContact.getAttribute('data-label-'+selectContact.value);

  form.setAttribute('data-contact-type', selectContact.value);
  inputContact.setAttribute('placeholder', placeholder + '*');
  inputContact.setAttribute('type', inputMap[selectContact.value] || 'text');
  inputContact.setAttribute('pattern', patternMap[selectContact.value] || "");
})